import type { UseTabsHook as BaseUseTabsHook } from "@fas/cpa-state-manager/redux/hooks/useTabs";
import { useTabs as useTabsBase } from "@fas/cpa-state-manager/redux/hooks/useTabs";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import environment from "environment";
import { setErrors } from "@fas/ui-framework";
import {
  USER_INFO_TAB,
  CONTACT_INFO_TAB,
  PAYMENT_METHODS_TAB,
  MAIN_REPORT_TAB,
  TRANSACTION_REPORT_TAB,
  DEFAULT_POSTBACK_TAB,
  ADDITIONAL_POSTBACKS_TAB,
  INFO_POSTBACKS_TAB,
} from "../../constants";

export type UseTabsArgs = {
  key: string;
};
export type UseTabsHook = Omit<BaseUseTabsHook, "onSwitchTab"> & {
  onSwitchTab: (arg0: keyof typeof tabsToParams) => unknown;
};
export const tabsToParams = {
  [USER_INFO_TAB]: environment.links.profile.replace(":page", "user"),
  [CONTACT_INFO_TAB]: environment.links.profile.replace(":page", "contact"),
  [PAYMENT_METHODS_TAB]: environment.links.profile.replace(":page", "payment"),
  [MAIN_REPORT_TAB]: environment.links.reports.replace(":type", "main"),
  [TRANSACTION_REPORT_TAB]: environment.links.reports.replace(
    ":type",
    "transaction"
  ),
  [DEFAULT_POSTBACK_TAB]: environment.links.postbacks.replace(
    ":type",
    "defaulPostback"
  ),
  [ADDITIONAL_POSTBACKS_TAB]: environment.links.postbacks.replace(
    ":type",
    "additionalPostback"
  ),
  [INFO_POSTBACKS_TAB]: environment.links.postbacks.replace(
    ":type",
    "infoPostback"
  ),
};
export const useTabs = ({ key }: UseTabsArgs): UseTabsHook => {
  const dispatch = useDispatch();
  const { onSwitchTab: switchTab, ...rest } = useTabsBase(key);
  const navigate = useNavigate();

  const onSwitchTab = (current: keyof typeof tabsToParams) => {
    switchTab(current);
    dispatch(setErrors({}));
    navigate(tabsToParams[current]);
  };

  return {
    ...rest,
    onSwitchTab,
  };
};
